import Marquee from "react-fast-marquee";

const items = [
  "Innus Lace Centre Art & Craft",
  "Premium Laces & Trims",
  "Karuna Complex, Court Road",
  "N. Paravur",
  "Call 73565 72909",
  "Secure Online Payments",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="py-8 md:py-10 border-y border-[#E8E4DF] bg-[#F2EFEB] overflow-hidden"
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif-d italic text-2xl md:text-3xl tracking-wide text-[#C5A059] px-6 whitespace-nowrap">
            {t}
          </span>
          <span className="text-[#C5A059]/50 text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
